import React, { useState, useRef, useContext, useEffect } from "react";
import "../styles/WhatsAppSettings.css";
import headeLogo from "../assets/images/shersoftnavLogo.png";
import close from "../assets/images/CreateCompanyImages/Wrong (1).webp";
import ComboBox from "./ComboBox";
import send from "../assets/images/CreateCompanyImages/send.webp";
import exit from "../assets/images/CreateCompanyImages/Cdbexit.webp";
import crtCmp from "../assets/images/CreateCompanyImages/CreateCmp.webp";

import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import binImg from "../assets/images/Bin.png";

function WhatsAppSettings({ onClose }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  //console.log("apiBaseUrl",apiBaseUrl);
  
  const authKey = process.env.REACT_APP_SHERWS_SENDER_AUTHKEY;
  //console.log("authKey=", authKey);

  const [isLoading, setIsLoading] = useState(true);
  const tableContainerRef = useRef(null);

  const spinnerProps = {
    color: "#026CC3",
    height: 12,
    width: 5,
    radius: 1,
    margin: 3,
    size: 30,
    speedMultiplier: 0.8, // Slightly slower animation
    css: {
      opacity: "0.8", // Slightly transparent
    },
  };
  const { agentCode } = useContext(AuthContext);
  const [selectedRow, setSelectedRow] = useState(null);
  const selectref = useRef(null);
  const textareaRef = useRef(null);
  const [WhatsAppsettingsData, setWhatsAppsettingsData] = useState({
    EntryName: "",
    Message: "",
    appkey: "",
    authkey: "",
    senderNo: "",
    Media: null,
  });
  // //console.log("WhatsAppsettingsData=", WhatsAppsettingsData);
  const [tableData, setTableData] = useState([]);
  const handleclear = () => {
    setWhatsAppsettingsData({
      ...WhatsAppsettingsData,
      EntryName: "",
      Message: "",
      appkey: "",
      authkey: "",
      senderNo: "",
    });
  };
  const fetchWhatsAppsettings = async (eName) => {
    if (!eName) {
      return;
    }
    handleclear();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/selectwhtAppapidatas/${eName}`
      );

      const whtAppstngsData = response.data[0];
      //console.log("fetchedData=", whtAppstngsData);

      setWhatsAppsettingsData({
        ...WhatsAppsettingsData,
        EntryName: whtAppstngsData.Voucher,
        Message: whtAppstngsData.MessageBody,
        appkey: whtAppstngsData.appKey,
        authkey: whtAppstngsData.Authkey,
        senderNo: whtAppstngsData.SenderNumber,
      });
    } catch (error) {
      console.error("Error fetching WhatsAppsettings Values:", error.message);
    }
  };

  const fetchNumber = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/selectAllschemeData`
      );

      const numbers = response.data;
      setTableData(response.data);

      // //console.log("numbers=", numbers);
    } catch (error) {
      console.error("Error fetching WhatsAppsettings numbers :", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNumber();
  }, [apiBaseUrl]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === "Return") {
      fetchWhatsAppsettings(event.target.value);
    }
  };

  const removeRow = (index) => {
    const newTableData = [...tableData];
    newTableData.splice(index, 1);
    setTableData(newTableData);
  };

  const handleSave = async () => {
    if (
      WhatsAppsettingsData.EntryName === "" ||
      WhatsAppsettingsData.Message === "" ||
      WhatsAppsettingsData.appkey === ""
    ) {
      alert("Enter Data Correctly");
      return;
    }
    try {
      const response = await axios.post(
        `${apiBaseUrl}/whatsAppsetting`,
        WhatsAppsettingsData
      );

      if (response.status === 200) {
        alert("Entry Saved");
      } else {
        // Handle other response statuses or errors
        console.error("Error submitting data:", response.data);
        alert("Error submitting data:");
      }
    } catch (error) {
      console.error("Error saving rateClass Values:", error.message);
    }
  };

  const handleSend = async () => {
    if (!WhatsAppsettingsData.Message || !WhatsAppsettingsData.appkey) {
      alert("Enter Data Correctly.");
      return;
    }
  
    let fileUrl = null;
  
    // If a media file is present, upload it
    if (WhatsAppsettingsData.Media) {
      try {
        const originalFile = WhatsAppsettingsData.Media;
        const newFileName = originalFile.name.replace(/\s+/g, "_");
        const modifiedFile = new File([originalFile], newFileName, {
          type: originalFile.type,
        });
  
        const formData = new FormData();
        formData.append("id", "shergoldErp"); // Folder name as "shergoldErp"
        formData.append("file", modifiedFile);
  
        const uploadResponse = await axios.post(
          "http://imageupload.shersoft.tech/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (uploadResponse.status === 200) {
          fileUrl = `http://imageupload.shersoft.tech/image/shergoldErp/${newFileName}`;
        } else {
          console.error("File upload failed:", uploadResponse.data);
          alert("File upload failed");
          return;
        }
      } catch (error) {
        console.error("Error during file upload:", error.message);
        return;
      }
    }
  
    // Send message to each phone number in the table
    for (const rowData of tableData) {
      try {
        const phoneNumber = `91${rowData.mobileNo}`;
        const messageData = new FormData();
        messageData.append("appkey", WhatsAppsettingsData.appkey);
        messageData.append("authkey", authKey);
        messageData.append("to", phoneNumber);
        messageData.append("message", WhatsAppsettingsData.Message);
  
        // Only attach file if it exists
        if (fileUrl) {
          messageData.append("file", fileUrl);
        }
  
        const messageResponse = await axios.post(
          "https://sherwasender.in/api/create-message",
          messageData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (messageResponse.status === 200) {
          // //console.log(`Message sent to ${phoneNumber}:`, messageResponse.data);
        } else {
          // console.error(`Failed to send to ${phoneNumber}:`, messageResponse.data);
        }
      } catch (error) {
        console.error("Error sending message:", error.message);
      }
    }
    alert("Messages sent successfully!");
  };
  

  return (
    <form className="WhatsAppsettingsRoot">
      <div className="WhatsAppsettingsHead">
        <div className="WhatsAppsettingsHeadpart">
          <img src={headeLogo} alt="SS" />
          <label>WhatsApp Settings</label>
        </div>
        <div className="WhatsAppsettingsHeadControlls">
          <button
            className="WhatsAppsettingscontrollsbuttons smsXbutton"
            onClick={onClose}
          >
            <img src={close} alt="X" />
          </button>
        </div>
      </div>
   
      <div className="WhatsAppsettingsBody">
        <div className="WhatsAppsettingsrow">
          <label>Entry Name</label>
          <ComboBox
            options={[
              [1, "SCHEME RECEIPT"],
              [2, "SALES"],
            ]}
            findedValue={
              Array.isArray(WhatsAppsettingsData.EntryName)
                ? WhatsAppsettingsData.EntryName[1]
                : WhatsAppsettingsData.EntryName
            }
            className="WhatsAppsettingsSelect"
            comboRef={selectref}
            onInputChange={(e) =>
              setWhatsAppsettingsData({
                ...WhatsAppsettingsData,
                EntryName: e,
              })
            }
            onKeyDown={handleKeyDown}
            onBlur={(e) => fetchWhatsAppsettings(e.target.value)}
          />
        </div>
        <div className="WhatsAppsettingscontent">
          <div className="WhatsAppsettingstemplate">
            <label>Message</label>
            <textarea
              className="WhatsAppsettingstextarea"
              ref={textareaRef}
              value={WhatsAppsettingsData.Message}
              onChange={(e) =>
                setWhatsAppsettingsData({
                  ...WhatsAppsettingsData,
                  Message: e.target.value,
                })
              }
            />
          </div>
          <div className="WhatsAppsettingsvariables">
            <div className="WhatsAppsettingsvariablessec1">
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <ClipLoader {...spinnerProps} />
                </div>
              ) : (
                <div
                  className="whNumbersTable"
                  // onScroll={handleScroll}
                  ref={tableContainerRef}
                >
                  <table>
                    <thead className="whNumbersTableHead">
                      <tr>
                        <th>Customer Name</th>

                        <th>Number</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="whNumbersTableBodyStyle">
                      {tableData.map((rowData, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className={`whNumbersTableBodyStyletr ${
                            rowData.atType === "Sub Total"
                              ? "redRow"
                              : rowData.atType === "Total"
                              ? "blueRow"
                              : ""
                          }`}
                        >
                          <td className="whNumbersTableDataBoxName pl-2">
                            {rowData.CustomerName}
                          </td>
                          <td
                            className="whNumbersTableDataBoxNumber"
                            style={{ textAlign: "right", paddingRight: "10px" }}
                          >
                            {rowData.mobileNo}
                          </td>
                          <td
                            className="whNumbersTableDataBoxBin text-center"
                            onClick={(event) => removeRow(rowIndex)}
                          >
                            <img src={binImg} alt="binImg" />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="WhatsAppsettingsrow">
          <label htmlFor="api">Media</label>
          <input
            className="smsapiLink"
            type="file"
            id="api"
            onChange={(e) =>
              setWhatsAppsettingsData({
                ...WhatsAppsettingsData,
                Media: e.target.files[0],
              })
            }
          />
        </div>
        <div className="WhatsAppsettingsrow">
          <label htmlFor="appkey">App Key</label>
          <input
            className="smsapiLink"
            type="text"
            id="appkey"
            value={WhatsAppsettingsData.appkey}
            onChange={(e) =>
              setWhatsAppsettingsData({
                ...WhatsAppsettingsData,
                appkey: e.target.value,
              })
            }
            required
          />
        </div>
        {/* <div className="WhatsAppsettingsrow">
          <label htmlFor="authkey">Auth Key</label>
          <input
            className="smsapiLink"
            type="text"
            id="authkey"
            value={WhatsAppsettingsData.authkey}
            onChange={(e) =>
              setWhatsAppsettingsData({
                ...WhatsAppsettingsData,
                authkey: e.target.value,
              })
            }
            required
          />
        </div> */}
        {/* <div className="WhatsAppsettingsrow">
          <label htmlFor="snd">Sender Number</label>
          <input
            className="smsapiLink"
            type="text"
            id="snd"
            value={WhatsAppsettingsData.senderNo}
            onChange={(e) =>
              setWhatsAppsettingsData({
                ...WhatsAppsettingsData,
                senderNo: e.target.value,
              })
            }
            required
          />
        </div> */}

        <div className="WhatsAppsettingsControlls">
          <div className="WhatsAppsettingsButtons ml-5" onClick={handleSend}>
            <img src={send} alt="Send" />
            <label htmlFor="">Send</label>
          </div>
          <div className="WhatsAppsettingsButtons" onClick={handleSave}>
            <img src={crtCmp} alt="Save" />
            <label htmlFor="">Save</label>
          </div>
          <div className="WhatsAppsettingsButtons" onClick={onClose}>
            <img src={exit} alt="Exit" />
            <label htmlFor="">Exit</label>
          </div>
        </div>
      </div>
    </form>
  );
}

export default WhatsAppSettings;
